import { useEffect, useState } from 'react'
import { fr_FR } from '../../translations'
import type { TranslationFile } from '../../models/translationsType'

const useTranslation = (instanceId?: string): TranslationFile => {
  const [current, setCurrent] = useState<TranslationFile>(fr_FR)

  const handleChange = (e: CustomEvent): void => {
    if (instanceId) {
      e.detail.instanceId === instanceId && setCurrent(e.detail.value)
    } else {
      setCurrent(e.detail.value)
    }
  }

  useEffect(() => {
    document.addEventListener('retorik_translation', ((e: CustomEvent) => handleChange(e)) as EventListener)
    // Dispatch event on mount to get the updated value in stead of the default one
    document.dispatchEvent(new Event('retorik_call_translation'))

    return () => {
      document.removeEventListener('retorik_translation', ((e: CustomEvent) => handleChange(e)) as EventListener)
    }
  }, [])

  return current
}

export default useTranslation
